module.exports = "/images/noApproved.svg";